import * as yup from 'yup';


import {geoConstants} from '../../../Geo';


// 250 million
export const REACH_MAX_DIGITAL = 50000000;
export const REACH_MAX_DIGITAL_SLIDER_STEP = Math.round(REACH_MAX_DIGITAL / 10);

// 10 million
export const REACH_MAX_PRINT = 1000000;
export const REACH_MAX_PRINT_SLIDER_STEP = Math.round(REACH_MAX_PRINT / 10);

export const SCHEMA_REACH_DIGITAL = yup.number()
    .nullable()
    .min(0)
    .max(REACH_MAX_DIGITAL)
    .default(0);

export const SCHEMA_REACH_PRINT = yup.number()
    .nullable()
    .min(0)
    .max(REACH_MAX_PRINT)
    .default(0);


export const SCHEMA_DISTRIBUTION = yup.object()
    .shape({
        countryAlpha2: geoConstants.SCHEMA_COUNTRY_ALPHA2,
        isPrimary: yup.boolean()
            .required()
            .default(false),
        reachDigital: SCHEMA_REACH_DIGITAL,
        reachPrint: SCHEMA_REACH_PRINT
    });
